import React from "react";
import { useSelector } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material";
import { themeCreator } from "./base";
import { RootState } from "../reduxServer/store";

const ThemeProviderWrapper = ({ children }) => {
  const mode = useSelector((state: RootState) => state.theme.mode);
  const lang = sessionStorage.getItem("lang") || "en";

  // 1️⃣ Get your existing custom theme
  const baseTheme = themeCreator(
    mode === "light" ? "PureLightTheme" : "PureDarkTheme"
  );

  // 2️⃣ Extend it with RTL / LTR
  const theme = createTheme({
    ...baseTheme,
    direction: lang === "ar" ? "rtl" : "ltr"
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderWrapper;
